import { checkResolution } from 'Functions/helpers'
import { updateLazy } from 'Functions/lazy';
import { scrollToEl } from 'Functions/window';
import Swiper, { Pagination, Navigation } from 'swiper';
import { Vue } from 'Common/vue';

import 'Layouts/default';

import 'Ui/more-items';
import 'Ui/shorten';
import 'Ui/tabs';
import 'Ui/favorite-trigger';
import 'Ui/slider';
import './catalog-jquery';
import './filter-slider';

Swiper.use([Pagination, Navigation]);

const catFilterElem = document.querySelector('#categoriesFilter');
const filterElem = document.getElementById("filter");

if (catFilterElem) {
    const productsCategories = catFilterElem.dataset.categories;
    const selectedCategoryId = catFilterElem.dataset.selected;

    new Vue({
        el: '#categoriesFilter',
        components: {
            CategoriesFilter: () => import('VueComponents/CategoriesFilter.vue')
        },
        template: `<CategoriesFilter :select-category-id="${selectedCategoryId || null}" :products-categories="${productsCategories}"></CategoriesFilter>`
    });
}

if (filterElem !== null) {
    filterElem.addEventListener("category.changed", function (e) {
        const categoryId = e.detail.category_id;
        const filterCategoryIdInput = document.getElementById('filterCategoryId');

        if (filterCategoryIdInput) {
            filterCategoryIdInput.value = categoryId;
        }
        Filter.submit();
    });
}

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.l-listing-main__content'), 0)
        })
    }
}

Event.on('Listing.fetchedData', () => {
    updateLazy()
    attachPaginatorEvents()

    if ($('.js-pager-current-count').length) {
        $('.js-pager-current-count').html($('.listing.products').first().find('.products__item').length);
    }
})

document.querySelectorAll('.js-show-all-subcategories').forEach(trigger => (
    trigger.addEventListener('click', () => {
        trigger.parentNode.classList.add('is-active');
        trigger.classList.remove('cxs-is-visible');
    })
));

document.addEventListener('DOMContentLoaded', function() {
    attachPaginatorEvents();
});